// GenerarPDF.js
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatRemuneracion } from '../Validations/TrabajadoresValidation';
import { getEmpresaByNombre } from '../Componentes/empresasConfig';

export const generarPDF = (rows, datosSueldo) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const marginLeft = 20;
    const marginRight = 20;
    const contentWidth = pageWidth - marginLeft - marginRight;

    // Color azul oscuro principal
    const azul = [27, 42, 74];

    const empresaInfo = getEmpresaByNombre(datosSueldo.empresa);
    const rutEmpresa = empresaInfo ? empresaInfo.rutFormatted : "";

    const obtenerFechaFormateada = (diasSumar = 0, mesesSumar = 0) => {
        const fecha = new Date();
        if (diasSumar) fecha.setDate(fecha.getDate() + diasSumar);
        if (mesesSumar) fecha.setMonth(fecha.getMonth() + mesesSumar);
        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const numeroCot = "CP " + String(datosSueldo.idCotizacion);

    // ====== HEADER ======
    // Nombre empresa (izquierda)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(...azul);
    doc.text(String(datosSueldo.empresa), marginLeft, 30);

    // RUT empresa + dirección
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text("RUT: " + rutEmpresa + "  |  Los Carrera Poniente 301, piso 2", marginLeft, 37);

    // Caja azul derecha con número de cotización
    const boxWidth = 55;
    const boxHeight = 22;
    const boxX = pageWidth - marginRight - boxWidth;
    const boxY = 18;
    doc.setFillColor(...azul);
    doc.roundedRect(boxX, boxY, boxWidth, boxHeight, 2, 2, "F");

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(255, 255, 255);
    doc.text("COTIZACION", boxX + boxWidth / 2, boxY + 8, { align: "center" });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(numeroCot, boxX + boxWidth / 2, boxY + 17, { align: "center" });

    // ====== LINEA SEPARADORA ======
    let y = 48;
    doc.setDrawColor(...azul);
    doc.setLineWidth(0.8);
    doc.line(marginLeft, y, pageWidth - marginRight, y);

    // ====== FECHAS ======
    y = 58;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);

    doc.setFont("helvetica", "bold");
    doc.text("Fecha:", marginLeft, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.fechaactual || obtenerFechaFormateada()), marginLeft + 30, y);

    doc.setFont("helvetica", "bold");
    doc.text("Válido hasta:", marginLeft + 80, y);
    doc.setFont("helvetica", "normal");
    doc.text(obtenerFechaFormateada(0, 1), marginLeft + 115, y);

    // ====== DATOS DEL CLIENTE ======
    y = 70;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(...azul);
    doc.text("DATOS DEL CLIENTE", marginLeft, y);

    y = 72;
    doc.setDrawColor(...azul);
    doc.setLineWidth(0.3);
    doc.line(marginLeft, y, pageWidth - marginRight, y);

    y = 80;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);

    const labelX = marginLeft;
    const valueX = marginLeft + 28;
    const col2LabelX = marginLeft + 95;
    const col2ValueX = marginLeft + 120;

    doc.setFont("helvetica", "bold");
    doc.text("Nombre:", labelX, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.nombreEmpresa || ""), valueX, y);

    doc.setFont("helvetica", "bold");
    doc.text("RUT:", col2LabelX, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.rutempresa || ""), col2ValueX, y);

    y += 6;
    doc.setFont("helvetica", "bold");
    doc.text("Dirección:", labelX, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.direccion || ""), valueX, y);

    doc.setFont("helvetica", "bold");
    doc.text("Teléfono:", col2LabelX, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.telefono || ""), col2ValueX, y);

    y += 6;
    doc.setFont("helvetica", "bold");
    doc.text("E-mail:", labelX, y);
    doc.setFont("helvetica", "normal");
    doc.text(String(datosSueldo.email || ""), valueX, y);

    // ====== CONCEPTO (título cotización) ======
    y = 105;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(...azul);
    doc.text("CONCEPTO", marginLeft, y);

    y = 107;
    doc.setDrawColor(...azul);
    doc.setLineWidth(0.3);
    doc.line(marginLeft, y, pageWidth - marginRight, y);

    y = 114;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    const tituloLines = doc.splitTextToSize(String(datosSueldo.tituloCotizacion || ""), contentWidth);
    doc.text(tituloLines, marginLeft, y);
    y += tituloLines.length * 5 + 5;

    // ====== DETALLE SUELDO ======
    y += 3;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(...azul);
    doc.text("DETALLE SUELDO", marginLeft, y);
    doc.setDrawColor(...azul);
    doc.setLineWidth(0.3);
    doc.line(marginLeft, y + 2, pageWidth - marginRight, y + 2);

    y += 8;

    const ipc = Number(datosSueldo.ipc || 0);
    const base = Number(datosSueldo.TotalFijoTrabajador || 0);
    const montoIPC = Math.round(base * (ipc / 100));
    const totaltotal = Math.round(base + montoIPC);

    const sueldoColumns = ["Descripción", `Valor ${datosSueldo.cantidadHora || 0} horas extra`];
    const sueldoRows = [
        ["Sueldo Base", `$${formatRemuneracion(String(datosSueldo.sueldoBase))}`],
        ["Gratificación", `$${formatRemuneracion(String(datosSueldo.gratificacion))}`],
        ["Horas extras pp", `$${formatRemuneracion(String(datosSueldo.horaextrapp))}`],
        ["SUBTOTAL IMPONIBLE", `$${formatRemuneracion(String(datosSueldo.subTotalImponible))}`],
        ["Cap individual (0.1%)", `$${formatRemuneracion(String(Math.round(datosSueldo.subTotalImponible * 0.001)))}`],
        ["Expectativa vida (0.9%)", `$${formatRemuneracion(String(Math.round(datosSueldo.subTotalImponible * 0.009)))}`],
        ["Movilización", `$${formatRemuneracion(String(datosSueldo.movilizacion))}`],
        ["Colación", `$${formatRemuneracion(String(datosSueldo.TotalColacion))}`],
        ["SIS", `$${formatRemuneracion(String(datosSueldo.valorSIS))}`],
        ["Mutual", `$${formatRemuneracion(String(datosSueldo.valorMututal))}`],
        ["Seguro Cesantía", `$${formatRemuneracion(String(datosSueldo.valorseguroCesantia))}`],
        ["COSTO TOTAL NETO", `$${formatRemuneracion(String(datosSueldo.valorCostoTotalNeto))}`],
        ["Administración general", `$${formatRemuneracion(String(datosSueldo.administracion))}`],
        ["Indemnización del trabajador", `$${formatRemuneracion(String(datosSueldo.indemnizacion))}`],
        ["COSTO VARIABLE EPP", `$${formatRemuneracion(String(datosSueldo.TotalEPP))}`],
        [`Utilidad ${formatRemuneracion(String(datosSueldo.utilidad))} %`, `$${formatRemuneracion(String(datosSueldo.CalculoUtilidad))}`],
        ["COSTO INGRESO", `$${formatRemuneracion(String(datosSueldo.TotalFijoTrabajador))}`],
        [`IPC (${ipc}%)`, `$${formatRemuneracion(String(montoIPC))}`],
        ["TOTAL COSTO INGRESO", `$${formatRemuneracion(String(totaltotal))}`],
    ];

    doc.autoTable({
        startY: y,
        head: [sueldoColumns],
        body: sueldoRows,
        margin: { left: marginLeft, right: marginRight },
        styles: {
            lineColor: [220, 220, 220],
            lineWidth: 0.1,
            halign: 'center',
            textColor: [60, 60, 60],
            fontSize: 9,
            cellPadding: 4,
        },
        headStyles: {
            fillColor: [245, 245, 245],
            textColor: [...azul],
            fontStyle: 'bold',
            lineColor: [200, 200, 200],
            lineWidth: 0.2,
        },
        alternateRowStyles: {
            fillColor: [255, 255, 255],
        },
        columnStyles: {
            0: { halign: 'left' },
            1: { halign: 'right' },
        },
    });

    // ====== DETALLE COSTOS VARIABLES ======
    y = doc.lastAutoTable.finalY + 10;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(...azul);
    doc.text("DETALLE COSTOS VARIABLES", marginLeft, y);
    doc.setDrawColor(...azul);
    doc.setLineWidth(0.3);
    doc.line(marginLeft, y + 2, pageWidth - marginRight, y + 2);

    const serviceColumns = ["Descripción", "Cantidad", "Valor Neto", "IVA", "Valor Mes"];
    const serviceRows = rows.map((row) => [
        row.descripcion || "",
        row.cantidad,
        `$${formatRemuneracion(String(row.valorNeto))}`,
        `$${formatRemuneracion(String(row.valorIVA))}`,
        `$${formatRemuneracion(String(row.valorMes))}`,
    ]);

    doc.autoTable({
        startY: y + 6,
        head: [serviceColumns],
        body: serviceRows,
        margin: { left: marginLeft, right: marginRight },
        styles: {
            lineColor: [220, 220, 220],
            lineWidth: 0.1,
            halign: 'center',
            textColor: [60, 60, 60],
            fontSize: 9,
            cellPadding: 4,
        },
        headStyles: {
            fillColor: [245, 245, 245],
            textColor: [...azul],
            fontStyle: 'bold',
            lineColor: [200, 200, 200],
            lineWidth: 0.2,
        },
        alternateRowStyles: {
            fillColor: [255, 255, 255],
        },
        columnStyles: {
            2: { halign: 'right' },
            3: { halign: 'right' },
            4: { halign: 'right' },
        },
    });

    // ====== TABLA SUB-TOTAL (alineada a la derecha) ======
    doc.autoTable({
        startY: doc.lastAutoTable.finalY,
        body: [["SUB-TOTAL", `$${formatRemuneracion(String(totaltotal))}`]],
        margin: { left: pageWidth - marginRight - 56, right: marginRight },
        showHead: false,
        styles: {
            lineColor: [220, 220, 220],
            lineWidth: 0.2,
            textColor: [...azul],
            fontSize: 10,
            fontStyle: 'bold',
            cellPadding: 4,
            halign: 'right',
        },
        columnStyles: {
            0: { cellWidth: 28 },
            1: { cellWidth: 28 },
        },
    });

    // ====== FOOTER ======
    const footerY = pageHeight - 15;
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.line(marginLeft, footerY - 5, pageWidth - marginRight, footerY - 5);

    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    const footerText = `${datosSueldo.empresa}  |  RUT: ${rutEmpresa}  |  Documento generado electrónicamente`;
    doc.text(footerText, pageWidth / 2, footerY, { align: "center" });

    // Guardar PDF
    doc.save("Cotización_CP_" + datosSueldo.idCotizacion + ".pdf");
};

export default generarPDF;
